import type { NextFunction, Request, RequestHandler, Response } from 'express';
import type { z } from 'zod';

/** Express 4 does not catch rejected promises; this forwards them to the error handler. */
export const asyncHandler =
  (fn: (req: Request, res: Response, next: NextFunction) => Promise<unknown>): RequestHandler =>
  (req, res, next) => {
    fn(req, res, next).catch(next);
  };

/** Validates with Zod; a failure becomes a 400 VALIDATION_ERROR via the global error handler. */
export function parse<T extends z.ZodTypeAny>(schema: T, data: unknown): z.infer<T> {
  return schema.parse(data);
}

export const clientIp = (req: Request) => req.ip ?? null;

/** Standard paginated list query. */
export function pageParams(query: Record<string, unknown>, defaultSize = 25, maxSize = 200) {
  const page = Math.max(1, Number(query.page) || 1);
  const pageSize = Math.min(maxSize, Math.max(1, Number(query.pageSize) || defaultSize));
  return { page, pageSize, skip: (page - 1) * pageSize, take: pageSize };
}
